// extracted by mini-css-extract-plugin
export var active = "_27-d";
export var blink = "_27-e";
export var container = "_27-5";
export var controls = "_27-0";
export var controlsRight = "_27-1";
export var fakeCursor = "_27-c";
export var hidden = "_27-b";
export var quillContainerSmall = "_27-7";
export var quillEditor = "_27-6";
export var quillEditorSmall = "_27-8";
export var quillFormatButtons = "_27-a";
export var quillToolbar = "_27-9";
export var removePadding = "_27-2";
export var state = "_27-3";
export var stateTitle = "_27-4";